'use strict';

class Textbox extends Widget {
  _element: any;

  constructor(element: any) {
    super(element);
    this._element.keypress(this._onKeyDown.bind(this));
  }

  _onKeyDown(event: any) {
    if (event.keyCode === ui.KEY_CODES.ENTER) {
      this.emit('returnpressed');
    }
  }

  text(text: any) {
    if (text === undefined) {
      return this._element.val();
    } else {
      this._element.val(text);
    }
  }

  focus() {
    this._element.focus();
  }

  static Create() {
    return $('<input type="text" class="textbox" />');
  }
}

ui.Textbox = Textbox;
ui.textbox = ui.widgetConstructor('textbox', ui.Textbox);
